import React, { Fragment, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Checkbox, Paper, Table } from '@mui/material';
import {
    DataGrid, GridToolbarQuickFilter, GridToolbarFilterButton,
} from '@mui/x-data-grid';
import { v4 as uuidv4 } from 'uuid';
import { withRouter } from 'react-router-dom'
import Box from '@mui/material/Box';
import Button from '@mui/material/Button'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faFileInvoice, faFileZip } from '@fortawesome/free-solid-svg-icons'
library.add(faFileInvoice)
import { ObtenerInformacionCliente } from '../../../redux/DuckOrganismoCertificacion/SolicitudesFC01_OCDuck';
import moment from 'moment'
import { obtenerSolicitudesUIFC01EstatusAdminRecibidas, obtenerDictamen, obtenerSolicitudesUIFC01EstatusAuxiliarRecibidas } from '../../../redux/DuckOrganismoCertificacion/EstatusSolicitudesUIF01Duck'
import ModalAsignarReasignarComponent from './ModalAsignarReasignarComponent';
import { actualizarFC01_OCAccion } from '../../../redux/DuckOrganismoCertificacion/SolicitudesFC01_OCDuck';

function SolicitudesOrganismoComponent(props) {

    const dispatch = useDispatch()
    const fechaHoy = moment().format('YYYY-MM-DD')
    const solicitudes = useSelector(store => store.EstatusSolicitudesUIF01.solicitudes)
    const dataUser = useSelector(store => store.Usuario.user)
    React.useEffect(async () => {
        if (dataUser[0]?.idrol == 1) await dispatch(obtenerSolicitudesUIFC01EstatusAdminRecibidas(5))
        if (dataUser[0]?.idrol == 7) await dispatch(obtenerSolicitudesUIFC01EstatusAuxiliarRecibidas(dataUser?.[0].usuario))
    }, [])

    //ACTUALIZAR PAGINA CUANDO CAMBIEN LAS SOLICITUDES??
    React.useEffect(() => {
    }, [solicitudes])

    const columns = [

        { field: 'tipoSolicitud', headerAlign: 'center', headerName: 'Tipo de servicio', width: 300, },
        { field: 'folio', headerAlign: 'center', headerName: 'Folio', width: 130 },
        { field: 'numerosocio', headerAlign: 'center', headerName: 'No. de socio', width: 120 },
        { field: 'nombrerazonsocial', headerAlign: 'center', headerName: 'Razón social', width: 320 },
        { field: 'revisor', headerAlign: 'center', headerName: 'Revisor', width: 200 },
        { field: 'accion', headerAlign: 'center', headerName: 'Acción', width: 200,
            renderCell: (params) =>
                <div className='row'>
                    <ThemeProvider theme={theme}>
                        {dataUser[0]?.idrol == 1 && params?.row?.data?.ocsolicitudfc01?.[0]?.revisor != null &&
                            params?.row?.data?.ocsolicitudfc01?.[0]?.revisor != undefined && params?.row?.data?.ocsolicitudfc01?.[0]?.revisor != '' &&
                            <div className="col-6">
                                <Button variant="contained" color="secondary" style={{ width: '100%' }} onClick={() => Asignacion(params)}>Reasignar</Button>
                            </div>
                        }
                        {dataUser[0]?.idrol == 1 && (params?.row?.data?.ocsolicitudfc01?.[0]?.revisor == null ||
                            params?.row?.data?.ocsolicitudfc01?.[0]?.revisor == undefined || params?.row?.data?.ocsolicitudfc01?.[0]?.revisor == '') &&
                            <div className="col-6">
                                <Button variant="contained" color="secondary" style={{ width: '100%' }} onClick={() => Asignacion(params)}>Asignar</Button>
                            </div>
                        }
                        {dataUser[0]?.idrol == 1 && params?.row?.data?.ocsolicitudfc01?.[0]?.revisor != null && params?.row?.data?.ocsolicitudfc01?.[0]?.revisor != undefined &&
                            params?.row?.data?.ocsolicitudfc01?.[0]?.revisor != '' &&
                            <div className="col-6">
                                <Button variant="contained" color="primary" style={{ width: '100%' }} onClick={() => Revisar(params)}>Revisar</Button>
                            </div>
                        }
                        {dataUser[0]?.idrol == 7 && params?.row?.data?.ocsolicitudfc01?.[0]?.revisor != null && params?.row?.data?.ocsolicitudfc01?.[0]?.revisor != undefined &&
                            params?.row?.data?.ocsolicitudfc01?.[0]?.revisor != '' &&
                            <div className="col-12">
                                <Button variant="contained" color="primary" style={{ width: '60%' }} onClick={() => Revisar(params)}>Revisar</Button>
                            </div>
                        }
                    </ThemeProvider>
                </div>
        }
    ]

    let rows = []
    solicitudes?./*fc_01_solicitudderegistro.*/map(solicitud => {
        let revisor = ''
        if (solicitud?.fc_01_solicitudderegistro?.solicitudesuifc01?.[0]?.ocsolicitudfc01?.length > 0)
            revisor = solicitud?.fc_01_solicitudderegistro?.solicitudesuifc01?.[0]?.ocsolicitudfc01?.[0]?.revisor
        rows.push({
            id: uuidv4(), idfc01_solicitudregistro: solicitud.idfc01_solicitudregistro,
            numerosocio: solicitud.fc_01_solicitudderegistro.numerosocio,
            tipoSolicitud: 'Solicitud de inscripción',
            nombrerazonsocial: solicitud.fc_01_solicitudderegistro.nombrerazonsocial,
            idlogin: solicitud.fc_01_solicitudderegistro.idlogin, idsolicitudesuifc01: solicitud.idsolicitudesuifc01,
            data: solicitud, folio: solicitud.fc_01_solicitudderegistro.folio, revisor: revisor,
            idcliente: solicitud?.fc_01_solicitudderegistro?.login?.cliente?.[0]?.idcliente

        })
    })

    const Revisar = async (params) => {

        let fechaatendida = new Date(fechaHoy).toISOString()
        let data = {
            idestatusoc: 1, fechaatendida: fechaatendida, idcliente: params?.row?.idcliente,
            idsolicitudesocfc01: params?.row?.data?.ocsolicitudfc01?.[0]?.idsolicitudesocfc01
        }
        await dispatch(actualizarFC01_OCAccion(data))
        await dispatch(ObtenerInformacionCliente(params.row.idsolicitudesuifc01))
        props.history.push('/InformacionClienteComponent')
    }

    const [openModal, setOpenModal] = React.useState(false);
    const [row, setRow] = React.useState(false);

    const Asignacion = async (params) => {
        setOpenModal(true)
        setRow(params.row)
    }

    function QuickSearchToolbar() {
        return (
            <Box
                sx={{
                    p: 0.5,
                    pb: 0,
                    mb: 2,
                    textAlign: 'left',
                    height: 30,
                    width: '100%',
                    backgroundColor: 'white'
                }}>
                <GridToolbarQuickFilter style={{ backgroundColor: '#F8F9F9', width: '100%' }} placeholder='Búsqueda...' />
            </Box>
        );
    }

    const theme = createTheme({
        palette: {
            primary: {
                main: "#7D9A47"
            },
            secondary: {
                main: "#DC3545"
            }
        },
        typography: {
            fontFamily: "Montserrat",
            textTransform: 'none',
            button: {
                fontSize: 16,
                fontWeight: 500,
                fontFamily: "Montserrat",
                textTransform: 'none'
            }
        }
    });

    return (
        <Fragment>
            <div className='container'>
                <div className='row'>
                    <h3 className='text-center tm mt-5 pt-3' style={{ fontWeight: 'bolder' }}>CONTROL DE SOLICITUDES RECIBIDAS</h3><br />
                    <div style={{ height: 600, width: '100%', color: 'black' }}>
                        <DataGrid
                            rows={rows}
                            columns={columns}
                            pageSize={10}
                            components={{ Toolbar: QuickSearchToolbar }}
                            getRowHeight={() => 'auto'}
                            sx={{
                                boxShadow: 0,
                                color: 'black',
                                border: 0,
                                fontFamily: 'Montserrat',
                                '& .MuiDataGrid-cell': {
                                    display: 'block',
                                    position: 'relative',
                                    textAlign: 'center',
                                    paddingTop: '8px',
                                    paddingBottom: '10px'
                                },
                                '& .MuiDataGrid-columnHeaders': {
                                    backgroundColor: '#0C365A',
                                    color: 'white',
                                    fontFamily: 'Montserrat',
                                    fontWeight: 'bold',
                                    height: '20px'
                                }
                            }}
                        />
                    </div>
                </div>
            </div>
            {openModal && <ModalAsignarReasignarComponent setOpenModal={setOpenModal} data={row} />}
        </Fragment>
    )
}
export default withRouter(SolicitudesOrganismoComponent)
